import { RT_TRD_GROUP_SET, SIGC_CMP_GROUP_SET } from "../../../function/GroupDataModel";
import { LogD } from "../../../function/LogLapper";
import { ComboBoxItemType } from "../../atoms/ComboBox/ItemComboBox";
import LearnResultDialog from "../../molecules/Dialog/LearnResultDialog";

export type SelectDataType = {
  mesid: number;
  devid: number;
  itemid: number;
  selectDate: Date;
  selectTime: string;
  isSelect: boolean;
  isShow: boolean;
}

export type MeasureInfoType = {
  AiCard: number;
  AiCh: number;
  DevIndex: number;
  DevName: string;
  DevNo: string;
  EntryNo: number;
  ItemName: string;
  ItemNameNo: number;
  KindNo: number;
  LogStart: string;
  MesName: string;
  PlcNo: number;
  FftInvalid: number;

  SetNo: number;
  Speed: number;
  selectDay: string;
  selectTime: string;
  name: string;
  id: number;
};

export type LineInfo = {
  FileName: string;
  MaxValue: number;
  MinValue: number;
  YaxisOffset: number;
  XaxisStartIndex: number;
  XaxisSpanCount: number;
  SamplingRate: number;
  XValues: number[];
  YValues: number[];
  UnitSymbol: string;
  ItemName: string;
}

export type RawWaveComparisonData = {
  OneLineData: LineInfo;
  TowLineData: LineInfo;
  YaxisMax: number;
  YaxisMin: number;
  XaxisMax: number;
  XaxisMin: number;
}


/**
 *選択データ初期値作成
 * @returns
 */
export const CreateDefalutSelectDataType = (): SelectDataType => {
  return ({
    devid: 1,
    mesid: 1,
    itemid: 1,
    selectDate: new Date(),
    selectTime: '',
    isSelect: false,
    isShow: true,
  })
}

/**
 *デバイス情報を取得
 * @returns
 */
export const GetMeasureInfoType = (): Promise<MeasureInfoType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/MeasuleInfo")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: MeasureInfoType[]) => {
        if (result != null) {
          console.debug(["api/MeasuleInfo - ok", result]);
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      }).catch((error) => {
        console.log(error);
        reject(error);
      })
  });
};

/**
 * 指定されたデータの直近のファイル時間取得
 * @param plcNo
 * @param aiNo
 * @param chNo
 * @param targetDay
 * @returns
 */
export const GetDataTimeList = (plcNo: number, aiNo: number, chNo: number, targetDay: string, conanNameNo: number): Promise<string[]> => {
  const query_params = new URLSearchParams({
    plcNo: String(plcNo),
    aiCardNo: String(aiNo),
    channelNo: String(chNo),
    targetTime: targetDay,
    conanNameNo: String(conanNameNo),
  });
  console.debug(["GetDataTimeList - ulr", "api/RawWaveComparison/GetDataTimeList?" + query_params])
  const url = `api/RawWaveComparisonConan/GetConanDataTimeList?${query_params}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: string[]) => {
        console.debug(result);
        if (DataTimeListValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
const DataTimeListValidate = (data: string[]) => {
  LogD(`DataTimeListValidate ckeck ${data}`, true);
  if (data == undefined) return false;
  LogD("DataTimeListValidate ckeck ok", true);
  return true;
};

//CSVファイルの存在する時間リストを取得
export const GetLatesTime = (conanNameNo: number, plcNo?: number, aiCardNo?: number, channelNo?: number): Promise<string> => {
  return new Promise((resolve, reject) => {
    const url = `api/RawWaveComparisonConan/GetConanDataLatestTime?plcNo=${plcNo}&&aiCardNo=${aiCardNo}&&channelNo=${channelNo}&&conanNameNo=${conanNameNo}`;
    console.debug(url);
    fetch(url)
      .then((res) => res.json())
      .then((result: string) => {
        console.debug(result);
        if (LatesTimeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const LatesTimeValidate = (data: string) => {
  console.debug("LatesTimeValidate ckeck");
  if (data == undefined) return false;
  LogD("LatesTimeValidate ckeck ok", true);
  return true;
};




export const GetGraphLineData = (
  plcNo1: number, aiNo1: number, chNo1: number, targetDay1: string, conanNameNo1: number,
  plcNo2: number, aiNo2: number, chNo2: number, targetDay2: string, conanNameNo2: number): Promise<RawWaveComparisonData> => {
  console.debug("GetDataTimeList exec");
  const url = `api/RawWaveComparisonConan/GetConanGraphLineData?plcNo1=${plcNo1}&&aiCardNo1=${aiNo1}&&channelNo1=${chNo1}&&targetTime1=${targetDay1}&&conanNameNo1=${conanNameNo1}
    &&plcNo2=${plcNo2}&aiCardNo2=${aiNo2}&&channelNo2=${chNo2}&&targetTime2=${targetDay2}&&conanNameNo2=${conanNameNo2}`;
  //const param1 = `?plcNo1=${plcNo1}&aiCardNo1=${aiNo1}&channelNo1=${chNo1}&targetTime1=${targetDay1}`;
  //const param2 = `&plcNo2=${plcNo2}&aiCardNo2=${aiNo2}&channelNo2=${chNo2}&targetTime2=${targetDay2}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: RawWaveComparisonData) => {
        console.debug(result);
        if (GraphLineDataValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
const GraphLineDataValidate = (data: RawWaveComparisonData) => {
  LogD(`GraphLineDataValidate ckeck ${data}`, true);
  if (data == undefined) return false;
  LogD("GraphLineDataValidate ckeck ok", true);
  return true;
};


/**
 *MeasureInfoTypeのリストより、選択データのデータのMeasureInfoTypeを見つける
 * @param measureInfos　measureInfoリスト
 * @param selectData　選択データ
 * @returns
 */
export const FindMeasureInfo = (measureInfos: MeasureInfoType[], selectData: SelectDataType): MeasureInfoType | undefined => {
  var mes = measureInfos.find((item) => item.id === selectData.mesid);
  var dev = measureInfos.find((item) => item.id === selectData.devid);
  var itm = measureInfos.find((item) => item.id === selectData.itemid);
  var target = measureInfos.find((item) =>
    item.KindNo === mes?.KindNo
    && item.DevIndex === dev?.DevIndex
    && item.ItemNameNo === itm?.ItemNameNo
  );
  return target;
};

/**
 *
 * @param meslist
 * @param target
 * @returns
 */
export const CreateSelectData = (meslist: MeasureInfoType[], indexNo: number, target?: MeasureInfoType, gp?: SIGC_CMP_GROUP_SET): SelectDataType => {
  var ret: SelectDataType = {
    devid: -1,
    mesid: -1,
    itemid: -1,
    selectDate: new Date(),
    selectTime: '',
    isSelect: false,
    isShow: true,
  };

  if (target == undefined) {
    return ret;
  } else {
    //計測種別の書込み
    if (gp !== undefined) {
      if (indexNo === 1) {
        ret.mesid = gp.SET_NO1;
      } else {
        ret.mesid = gp.SET_NO2;
      }
    }

    //var mid = meslist.find((row) => row.PlcNo === target.PlcNo);
    //ret.mesid = mid != undefined ? mid.id : ret.mesid;

    var did = meslist.find((row) => row.DevIndex === target.DevIndex)
    ret.devid = did != undefined ? did.id : ret.devid;

    var iid = meslist.find((row) => row.PlcNo === target.PlcNo);
    ret.itemid = iid != undefined ? iid.id : ret.itemid;

    return ret;
  }
};
